import docCookies from 'doc-cookies';
import { BASE_URL_SANCTUM, RECAPTCHA_SITE_KEY } from '../common/const';
import { load } from 'recaptcha-v3';

export default function (topic) {
  return {
    form: null,
    topic: topic,
    email: '',
    sending: false,
    sent: false,

    init() {
      this.form = this.$refs.leadForm;
    },

    async getXsfrToken() {
      const response = await fetch(BASE_URL_SANCTUM);
      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }
    },

    get action() {
      return this.form.action;
    },
    
    async getRecaptchaToken(action) {
      const recaptcha = await load(RECAPTCHA_SITE_KEY);
      return await recaptcha.execute(action);
    },    

    async send() {
      this.sending = true;

      await this.getXsfrToken();

      const data = new URLSearchParams(new FormData(this.form));
  
      const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
      const token = await this.getRecaptchaToken(recaptchaAction);
  
      data.append('recaptcha_token', token);
      data.append('recaptcha_action', recaptchaAction);

      fetch('/lead/store', {
        body: data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
          'X-lead-id': this.leadId,
        },
        method: 'POST',
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || 'Něco se pokazilo. Zkuste to prosím znovu.');
          }
          return data;
        })
        .then((data) => {
          const dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: 'lead_form_submission',
            formType: 'primary',
            topic: this.topic,
          });
          this.sent = true;
        })
        .catch((error) => {
          console.error('Error submitting form:', error);
          this.sending = false;
          alert(error.message);
        });
    },
  };
}
